// extracted by mini-css-extract-plugin
export default {"TextEllipsis":"TextEllipsis_TextEllipsis__gRZxI"};